import React from 'react';
import classnames from 'classnames';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AutoFormatMessage } from 'common/libs/intl';
import { NAV_LINKS } from './FooterNavigation.constants';
import styles from './FooterNavigation.module.scss';

export default class FooterNavigation extends React.Component {
  renderNavLink = () => {
    return NAV_LINKS.map(o => {
      const navLinkProps: {[key: string]: any} = {
        key: o.key,
        className: classnames([styles.navLink]),
        [ o.is_external ? 'href' : 'to' ]: o.url,
        ...(o.is_external ? {} : {'as': Link}),
      };
      return (
        <Nav.Link {...navLinkProps}>
          <AutoFormatMessage message={o.message} />
        </Nav.Link>
      )
    });
  }

  render() {
    const year = (new Date()).getFullYear();
    return (
      <React.Fragment>
        <Nav className="flex-column align-items-center align-items-sm-end">
          { this.renderNavLink() }
        </Nav>
        <p className="text-center text-sm-right mt-3">
          Xpersity {year}
        </p>
      </React.Fragment>
    )
  }
}
